import qs from 'qs';
import axios from 'axios';

export default {
  postDicList(callback) {
    const url = '/api/folderList';
    const requestBody = {
    };

    const config = {
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Access-Control-Allow-Origin': '*',
      },
    };

    axios.post(url, qs.stringify(requestBody), config)
      .then((res) => {
        this.categoryList = res.data;
        callback(res.data);
      })
      .catch((err) => {
        console.log('folder list err but post', err);
      });
  },
};
